import InvoiceItemDetails from 'components/invoices/invoice-item-details';

export default function InvoiceDetails() {
  return <InvoiceItemDetails />;
}
